import ListView from "../common/ListView";
import styles from "./ProductLineUp.module.css";

/**
 * @author yjkim
 * @date 2022-10-05 09:53:11
 * @remark 회사소개 페이지 제품 라인업 박스
 * @returns <ProductLineUp/>
 */

export interface BoxProps {
    lightText: string;
    boldText: string;
    cssClassName?: any;
}

export function ProductLineUp() {
    const productLineUp = [
        {
            lightText: "IntraMap for",
            boldText: "Desktop",
            cssClassName: styles.intramap_desktop,
        },
        {
            lightText: "IntraMap for",
            boldText: "Server",
            cssClassName: styles.intramap_web,
        },
        {
            lightText: "IntraMap for",
            boldText: "Web",
            cssClassName: styles.intramap_server,
        },
        {
            lightText: "IntraMap for",
            boldText: "3D",
            cssClassName: styles.intramap_3d,
        },
    ];
    function renderItem(props: BoxProps) {
        return (
            <div key={props.boldText} className={`${styles.product_line_up_small_box} ${props.cssClassName}`}>
                <div className={styles.product_line_up_text_div}>
                    <p className={styles.product_line_up_medium}>{props.lightText}</p>
                    <p className={styles.product_line_up_bold}>{props.boldText}</p>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.product_line_up}>
            <ListView data={productLineUp} renderItem={renderItem} />
            <div className={styles.product_line_up_big_box}>
                <div className={styles.product_line_up_text_div}>
                    <p className={styles.umap_text}>uMap</p>
                </div>
            </div>
        </div>
    );
}
